<div class="domains-page page-shell">
  <mat-toolbar class="header">
    <span>{{ "domains.header" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="addDomain()"
        *ngIf="canAdd"
        [disabled]="isLoading"
      >
        <mat-icon>add</mat-icon>
        {{ "domains.new" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="domains-content">
    <div
      class="table-container"
      [class.table-container--empty]="!isLoading && dataSource.data.length === 0"
      [class.table-container--loading]="isLoading"
    >
      <mat-table [dataSource]="dataSource" class="mat-elevation-z0">
        <ng-container matColumnDef="expand">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              *ngIf="isOnMainDomain && isSubdomain(element)"
              class="subdomain-indicator"
              disabled
              [matTooltip]="'client.subdomain' | translate"
            >
              <mat-icon>remove</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="domain">
          <mat-header-cell *matHeaderCellDef>{{
            "domains.domain" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div
              class="name-wrapper"
              (click)="goToDomain(element.domain); $event.stopPropagation()"
              [matTooltip]="'domains.goToDomain' | translate"
            >
              <mat-icon>open_in_browser</mat-icon>
              <img
                [src]="element.photoUrl || '/assets/img/favicon.png'"
                alt="logo"
                class="client-image"
              />
              <div class="domain-info">
                <span>{{ element.name || "-" }}</span>
                <code>{{ element.domain }}</code>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="googleAdminEmail">
          <mat-header-cell *matHeaderCellDef>{{
            "domains.googleAdminEmail" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <code>{{ element.googleAdminEmail || "-" }}</code>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef>{{
            "domains.createdAt" | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span [matTooltip]="element.createdAt">
              {{ element.createdAt | localizedDate }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="table-actions">
              <button
                type="button"
                class="action-btn"
                (click)="editDomain(element); $event.stopPropagation()"
              >
                <mat-icon>edit</mat-icon>
                {{ "edit" | translate }}
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row--clickable"
          [class.subdomain]="isOnMainDomain && row.parentDomain"
          (click)="editDomain(row)"
        ></mat-row>
      </mat-table>

      <div class="loading-wrapper" *ngIf="isLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!isLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">language</mat-icon>
        <p>{{ "domains.empty" | translate }}</p>
      </div>
    </div>

    <div
      *ngIf="!isLoading && isReseller && resellerClientsDataSource.data.length > 0"
      class="reseller-clients-section"
    >
      <h3 class="section-title">{{ "domains.resellerClients" | translate }}</h3>

      <div class="table-container">
        <mat-table
          [dataSource]="resellerClientsDataSource"
          class="mat-elevation-z0"
        >
          <ng-container matColumnDef="domain">
            <mat-header-cell *matHeaderCellDef>{{
              "domains.domain" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div
                class="name-wrapper"
                (click)="switchToClient(element.domain)"
                [matTooltip]="'domains.goToDomain' | translate"
              >
                <mat-icon>open_in_browser</mat-icon>
                <img
                  [src]="element.photoUrl || '/assets/img/favicon.png'"
                  alt="logo"
                  class="client-image"
                />
                <div class="domain-info">
                  <span>{{ element.name || element.domain }}</span>
                  <code>{{ element.domain }}</code>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="licenseCount">
            <mat-header-cell *matHeaderCellDef>{{
              "domains.licenseCount" | translate
            }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.licenseCount || 0 }}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="resellerClientsColumns"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: resellerClientsColumns"
          ></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
